// extracted by mini-css-extract-plugin
export default {"mainWrraper":"style_mainWrraper__XCJK0","collapseWrraper":"style_collapseWrraper__2MH8q","plusIcon":"style_plusIcon__aKY+f"};